__turbopack_context__.v({
  "blockContainer": "ImageWithBlock-module-scss-module__wEaSmq__blockContainer",
  "imageContainer": "ImageWithBlock-module-scss-module__wEaSmq__imageContainer",
  "imageWithBlock": "ImageWithBlock-module-scss-module__wEaSmq__imageWithBlock",
  "noMargin": "ImageWithBlock-module-scss-module__wEaSmq__noMargin",
});
